import _ from "lodash";
import moment from 'moment';
import languageModel from '../../../../models/language.model';
import loginModel from '../../../../models/login.model'
import trainModel from "../../../../models/custom-vision/custom-vision.trains.model";
import projectModel from "../../../../models/custom-vision/custom-vision.projects.model";
import { Dialog } from 'construct-ui';
import ViewBase from '../../../view-base.view';
import paginationComponent from '../../../../components/pagination/pagination.component';
import SingleSelectCommonComponentView from '../../../../components/common/single-select-common-component.view'
import { formats } from '../../../../config/constants';
import CVIterationImagesListView from '../cvtrains/custom-vision-iteration-images-list.view';
import CVTrainingPerformanceEvaluateView from '../cvtrains/custom-vision.performance-evaluate.view';
import CVPerformanceDisplayDetailView from '../cvtrains/custom-vision.performance-display-detail.view';

import { easepick, AmpPlugin, RangePlugin, LockPlugin } from '@easepick/bundle';

export default function CVTrainingPerformanceListView() {
    ViewBase.call(this);

    const DATE_SEPARATOR = '   ~   ';
    let datePicker;

    let currentCountry;

    let inputDataModel = { searchStatus: '', fromDate: '', toDate: '', searchProjectId: 0, fromScore: 0, toScore: 100, totalCount: 0, pageIndex: 1, pageSize: 10 };
    let dateDisplayModel = { fromDate: '', toDate: '' };
    
    let list = [];
    let projectsList = [];
    let searchProjectSelectedItem = {};
    let processedStatusesList = [];
    let processedStatusSelectedItem = {};
    
    let needReset = true;
    let fromInitDate;
    let toInitDate;

    let selectedProjectId = 0;
    let selectedIterationId = 0;
    let isPopupIterationImagesListOpened = false;
    let isPopupUpdateScoreOpened = false;
    let selectedRecord;
    let selectedPredictionId = '';
    let isPopupDisplayDetailOpened = false;

    let initDateRangePicker = () => {
        let dateRangePickerEl = document.getElementById('report--date-range');

        if (!dateRangePickerEl) {
            return
        }
        datePicker = new easepick.create({
            element: dateRangePickerEl,
            css: [
                'static/css/easepick.css',
                'static/css/easepick-custom.css',
            ],
            autoApply: false,
            zIndex: 1000,
            readonly: false,
            format: 'YYYY.MM.DD',
            firstDay: 0, // 0 - Sun, 1 - Mon, ...
            grid: 2,
            calendars: 2,
            locale: {
                apply: this.getText("LT00000200", "Apply"),
                cancel: this.getText("LT00000057", "Cancel")
            },
            AmpPlugin: {
                dropdown: {
                    minYear: moment().subtract(5, 'years').format('YYYY'),
                    maxYear: moment().format('YYYY'),
                    years: true,
                    months: true
                },
                resetButton: true,
                darkMode: false
            },
            RangePlugin: {
                delimiter: DATE_SEPARATOR
            },
            LockPlugin: {
                minDate: moment(new Date()).subtract(5, 'years').startOf('year').format('YYYY-MM-DD'),
                maxDate: moment(new Date()).endOf('year').format('YYYY-MM-DD')
            },
            plugins: [
                AmpPlugin,
                RangePlugin,
                LockPlugin
            ],
            setup(datePicker) {
                datePicker.on('select', e => {
                    inputDataModel.fromDate = moment(e.detail.start).format(formats.apiDateFormat);
                    inputDataModel.toDate = moment(e.detail.end).format(formats.apiDateFormat);
                    
                    dateDisplayModel.fromDate = moment(e.detail.start).format(formats.dateFormat);
                    dateDisplayModel.toDate = moment(e.detail.end).format(formats.dateFormat);
                    _loadPerformanceRecords();
                })
            },
        });
    }

    let _getFromScore = (e) => {
        inputDataModel.fromScore = parseFloat(e.target.value);
        if (Number.isNaN(inputDataModel.fromScore) || !_.isNumber(inputDataModel.fromScore)) {
            inputDataModel.fromScore = 0;
        } else if (inputDataModel.fromScore < 0 || inputDataModel.fromScore > 100) {
            inputDataModel.fromScore = 0;
        }
    }

    let _getToScore = (e) => {
        inputDataModel.toScore = parseFloat(e.target.value);
        if (Number.isNaN(inputDataModel.toScore) || !_.isNumber(inputDataModel.toScore)) {
            inputDataModel.toScore = 100;
        } else if (inputDataModel.toScore < 0 || inputDataModel.toScore > 100) {
            inputDataModel.toScore = 100;
        }
    }

    let _loadPerformanceRecords = () => {
        this.showLoading();

        trainModel.getPerformanceRecordsList(
            _performanceRecordsSuccessCallBack,
            _performanceRecordsErrorCallBack,
            inputDataModel
        );
    }

    let _loadProjects = () => {

        projectModel.getProjectsList(
            (result) => {
                let listOfProjects = result;
                
                if (listOfProjects.length == 0) {
                    projectsList = [];
                }

                projectsList = [];
                projectsList.push({ code: "0", name: this.getText("LT00000397", "All Projects") });
                for(var i = 0; i < listOfProjects.length; i++) {
                    projectsList.push({ code: listOfProjects[i].id.toString(), name: listOfProjects[i].name });
                }
                searchProjectSelectedItem = { code: "0", name: this.getText("LT00000397", "All Projects") };

            }, (error) => {

                if (error.code == 404) { 
                    projectsList = [];
                }

                this.handleError(error);
            },
            false
        );
    }

    let _loadProcessedStatus = () => {
        processedStatusesList.push({ code: "", name: this.getText("LT00000143", "All") });
        processedStatusesList.push({ code: "Passed", name: this.getText("LT00000398", "Passed") });
        processedStatusesList.push({ code: "Failed", name: this.getText("LT00000399", "Failed") });

        processedStatusSelectedItem = { code: "", name: this.getText("LT00000143", "All") };
    }

    let onPageSizeChanged = (pageIndex, pageSize) => {
        inputDataModel.pageIndex = pageIndex;
        inputDataModel.pageSize = pageSize;
        _loadPerformanceRecords();
    }

    let onPageChanged = (pageIndex) => {
        inputDataModel.pageIndex = pageIndex;
        _loadPerformanceRecords();
    }

    let _performanceRecordsSuccessCallBack = (result) => {
        this.hideLoading();
        
        list = result.data;
        if (list == null) {
            list = [];
        }
        inputDataModel.totalCount = result.total;
        inputDataModel.pageIndex = result.pageIndex;
        inputDataModel.pageSize = result.pageSize;
    }

    let _performanceRecordsErrorCallBack = (error) => {
        this.hideLoading();

        list = [];

        this.handleError(error);
    }

    let _search = () => {
        inputDataModel.pageIndex = 1;
        _loadPerformanceRecords();
    }

    let _clearFilter = () => {
        inputDataModel.searchProjectId = 0;
        inputDataModel.fromScore = 0;
        inputDataModel.toScore = 100;
        _initControls();
    }

    // let _onDatePickerChange = (start, end) => {
    //     inputDataModel.fromDate = start;
    //     inputDataModel.toDate = end;
    // }

    let _initControls = () => {
        fromInitDate = moment(new Date()).subtract(1, 'month');
        toInitDate = moment(new Date());
        inputDataModel.fromDate = fromInitDate.format(formats.apiDateFormat);
        inputDataModel.toDate = toInitDate.format(formats.apiDateFormat);
        inputDataModel.searchProjectId = 0;
        searchProjectSelectedItem = { code: "0", name: this.getText("LT00000397", "All Projects") };
        inputDataModel.searchStatus = '';
        processedStatusSelectedItem = { code: "", name: this.getText("LT00000143", "All") };
        needReset = !needReset;
                    
        dateDisplayModel.fromDate = fromInitDate.format(formats.dateFormat);
        dateDisplayModel.toDate = toInitDate.format(formats.dateFormat);
    }

    let _showIterationImagesList = (projectId, iterationId) => {
        isPopupIterationImagesListOpened = true;

        selectedProjectId = projectId;
        selectedIterationId = iterationId;
    }

    let _showPerformanceEvaluationPopup = (record) => {
        isPopupUpdateScoreOpened = true;

        selectedRecord = record;
    }

    let onUpdateScoreComplete = () => {
        isPopupUpdateScoreOpened = false;        
        _loadPerformanceRecords();
    }

    let _showDisplayDetailPopup = (projectId, predictionId) => {
        isPopupDisplayDetailOpened = true;

        selectedProjectId = projectId;
        selectedPredictionId = predictionId;
    }

    return {
        oninit: (vnode) => {
            _initControls();
            currentCountry = loginModel.credentials.country;

            _loadProcessedStatus();
            _loadProjects();
            _loadPerformanceRecords();
        },
        onupdate: (vnode) => {
            if (loginModel.credentials.country !== currentCountry) {
                _loadProjects();
                _loadPerformanceRecords();
                currentCountry = loginModel.credentials.country;
            }
        },            
        oncreate: (vnode) => {
            initDateRangePicker();
        },
        view: (vnode) => {
            return [
                m('.row',
                    m('.col-md-12',
                        m('.d-flex.justify-content-end.mb-2',
                            m('a.btn.btn-outline-primary.btn-search[data-bs-toggle="collapse"][href="#showSearchBarRc"][role="button"][aria-controls="showSearchBar"][aria-expanded="false"]',
                                m('span.search-arrow.me-2',
                                    m('i.bi.bi-search')
                                ), this.getText("LT00000001", "Search")
                            )
                        ),
                        m('.searchbox.collapse[id="showSearchBarRc"]',
                            m('.card.mb-3',
                                m('.card-body.py-3',
                                    m('.row',
                                        m('.container',
                                            m('.row',
                                                m('.col-md-3',
                                                    m('label.form-label', this.getText("LT00000070", "Date Range")),
                                                    m('.easepick-input-group',
                                                        m('input#report--date-range.form-control', {
                                                            value: dateDisplayModel.fromDate + DATE_SEPARATOR + dateDisplayModel.toDate
                                                        }),
                                                        m('i.bi.bi-calendar-range-fill')
                                                    )
                                                ),
                                                m('.col-md-3',
                                                    m('label.form-label', this.getText("LT00000401", "Projects")),
                                                    m(SingleSelectCommonComponentView, {
                                                        iconList: [], 
                                                        selectedItem: searchProjectSelectedItem,
                                                        handleSelect: (item) => { inputDataModel.searchProjectId = parseInt(item["code"]); searchProjectSelectedItem = item; },
                                                        items: projectsList,
                                                    })
                                                ),
                                                m('.col-md-2',
                                                    m('label.form-label', this.getText("LT00000402", "Score From...")), 
                                                    m('input[type=number][required][maxlength=6][placeholder=' + this.getText("LT00000402", "Score From...") + '][value="' + inputDataModel.fromScore + '"].form-control.form-control-bg', { onchange: _getFromScore }),
                                                ),
                                                m('.col-md-2',
                                                    m('label.form-label', this.getText("LT00000403", "Score To...")), 
                                                    m('input[type=number][required][maxlength=6][placeholder=' + this.getText("LT00000403", "Score To...") + '][value="' + inputDataModel.toScore + '"].form-control.form-control-bg', { onchange: _getToScore }),
                                                ),
                                                m('.col-md-2.gap-2.d-sm-flex.mt-4',
                                                    m('button.btn.btn-primary.px-4.gap-3', { onclick: _search }, this.getText("LT00000001", "Search")),
                                                    m('button.btn.btn-white.px-4.gap-3', { onclick: _clearFilter }, this.getText("LT00000031", "Clear")),
                                                ),
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        m('.card',
                            m('.card-body',
                                list.length == 0 && m("div", { "class": "col-md-12" }, m("span", languageModel.getText("EM00000141", "No records found."))),
                                list.length > 0 && m("div", { "class": "col-md-12" },
                                    [
                                        list.map(function (record, index) {

                                            

                                            let _hasRepresentivePicture = (record.fileContent != '' && record.fileContent != null);

                                            let _recordScoreTextCss = 'text-primary';

                                            if (record.adjustedScore < record.warningScore) {
                                                _recordScoreTextCss = 'text-warning';
                                            }

                                            if (record.adjustedScore < record.alertingScore) {
                                                _recordScoreTextCss = 'text-danger';
                                            }

                                            let _issues = record.issues ? JSON.parse(record.issues) : [];

                                            return m("div", { "class": "customVision" }, [                
                                                m("div", { "class": "row" }, [
                                                    m("div", { "class": "col-md-2" },
                                                        !_hasRepresentivePicture && m('img.userImg[src="static/images/custom-vision/default.png"]', { "style": "width: 100%; min-height: 140px;" }),
                                                        _hasRepresentivePicture && m("img", { "src": record.fileContent, "style": "max-width: 100%;" })
                                                    ),
                                                    m("div", { "class": "col-md-7" }, [
                                                        m("span", { "class": "cvProjectTitle " + _recordScoreTextCss }, record.adjustedScore.toFixed(2) + '%'),
                                                        (record.adjustedScore != record.submissionScore) && m('label', languageModel.getText("LT00000404", "Submission Score"), m('span.badge.rounded-pill.bg-secondary', { "style": "margin-left: 6px;" }, record.submissionScore.toFixed(2) + '%')),
                                                        m("span", { "class": "cvProjectDescription text-secondary" }, 'Submitted by ' + record.createUserName +  (record.siteName != null ? (' from ' + record.siteName) : '')),
                                                        _issues.length > 0 && m("div", [
                                                            m('.mt-3', 'Possible Issues:'),
                                                            m('table.table.table-striped',
                                                                m('thead',
                                                                    m('tr',
                                                                        m('th', { scope: 'col' }, 'Tag'),
                                                                        m('th', { scope: 'col' }, 'Object'),
                                                                        m('th', { scope: 'col' }, 'Orientation'),
                                                                        m('th', { scope: 'col' }, 'Position'),
                                                                    )
                                                                ),
                                                                m('tbody',
                                                                    _issues.map(function (issue, index) {                                                                    
                                                                        return m('tr',
                                                                            m('th', { scope: 'row' }, issue.Tag),
                                                                            m('td', 
                                                                                issue.Object && m('i.bi.bi-check-circle-fill.text-success'),
                                                                                !issue.Object && m('i.bi.bi-x-circle-fill.text-danger')),
                                                                            m('td', 
                                                                                issue.Orientation && m('i.bi.bi-check-circle-fill.text-success'),
                                                                                issue.Orientation == null && m('span', '-'),
                                                                                issue.Orientation != null && !issue.Orientation && m('i.bi.bi-x-circle-fill.text-danger')),
                                                                            m('td', 
                                                                                issue.Position && m('i.bi.bi-check-circle-fill.text-success'),
                                                                                issue.Position == null && m('span', '-'),
                                                                                issue.Orientation != null && !issue.Position && m('i.bi.bi-x-circle-fill.text-danger')),
                                                                        );
            
                                                                    })
                                                                )
                                                                
                                                            ),
                                                            m('strong', 'User\'s Remarks: ' + record.remarks)
                                                            
                                                        ]),
                                                        m("div", { "class": "row cvProjectLinks" }),
                                                        m("div", { "class": "row cvProjectOperations" }, [
                                                            m("div", { "class": "col-md-2" }, m("a", { "href": "javascript:;", onclick:()=>{ _showPerformanceEvaluationPopup(record) } }, [m("i", { "class": "bi bi-clipboard-data" }), m("span", "Evaluate...")]))
                                                        ])
                                                    ]),
                                                    m("div", { "class": "col-md-3" }, [
                                                        m("div", { "class": "row cvProjectSideInfo" }, [
                                                            m("div", { "class": "col-sm-1" }, m("i", { "class": "bi bi-clock", "style": "font-size: 1.6em;" })),
                                                            m("div", { "class": "col-sm-11" }, m("div", { "style": "font-size: 0.8em;" }, [
                                                                m("div", "Created Date"),
                                                                m("div", record.createDateDisplay)
                                                            ])),
                                                        ]),
                                                        m("div", { "class": "row cvProjectSideInfo" }, [
                                                            m("div", { "class": "col-sm-1" }, m("i", { "class": "bi bi-clipboard-data", "style": "font-size: 1.6em;" })),
                                                            m("div", { "class": "col-sm-11" }, m("div", { "style": "font-size: 0.8em;" }, [
                                                                m("div", m("a", { "href": "javascript:;", onclick:()=>{ _showDisplayDetailPopup(record.projectId, record.transactionId); } }, m("span", record.configurationName))),
                                                                m("div", m("a", { "href": "javascript:;", onclick:()=>{ _showIterationImagesList(record.projectId, record.iterationId); } }, m("span", "View Setup...")))
                                                            ])),
                                                        ])
                                                    ]),
                                                ]),
                                                m("hr")
                                            ])
                                        })
                                    ]
                                ),
                                list.length > 0 && m(paginationComponent,
                                    {
                                        currentPage: inputDataModel.pageIndex,
                                        pageSize: inputDataModel.pageSize,
                                        totalItems: inputDataModel.totalCount,
                                        onPageChanged: onPageChanged,
                                        onPageSizeChanged: onPageSizeChanged
                                    }
                                )
                            )
                        )
                    ),
                    m(Dialog, {
                        isOpen: isPopupIterationImagesListOpened,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { isPopupIterationImagesListOpened = false; },
                        title: this.getText("LT00000405", "Iteration Training Images"),
                        content: m(CVIterationImagesListView, { 
                            onPopupClose: ()=>{ isPopupIterationImagesListOpened = false },
                            projectId: selectedProjectId,
                            iterationId: selectedIterationId
                        }),
                        "class": "cui-dialog-xxl"
                    }),
                    m(Dialog, {
                        isOpen: isPopupUpdateScoreOpened,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { isPopupUpdateScoreOpened = false; },
                        title: this.getText("LT00000406", "Update Score"),
                        content: m(CVTrainingPerformanceEvaluateView, { 
                            onPopupClose: ()=>{ isPopupUpdateScoreOpened = false; },
                            onSaveComplete: onUpdateScoreComplete,
                            record: selectedRecord
                        }),
                        "class": "cui-dialog-xxl"
                    }),
                    m(Dialog, {
                        isOpen: isPopupDisplayDetailOpened,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { isPopupDisplayDetailOpened = false; },
                        title: this.getText("LT00000407", "Display Setup"),
                        content: m(CVPerformanceDisplayDetailView, {
                            onPopupClose: () => { isPopupDisplayDetailOpened = false },
                            projectId: selectedProjectId,
                            predictionId: selectedPredictionId
                        }),
                        "class": "cui-dialog-xxl"
                    }),
                ),
                this.getBaseViews()
            ]
        }
    }
}
